import { render, staticRenderFns } from "./Autoevaluation.vue?vue&type=template&id=f60791da"
import script from "./Autoevaluation.vue?vue&type=script&lang=js"
export * from "./Autoevaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports